module.exports = __webpack_public_path__ + "static/img/LOGO-1.3e27c3b.png";


//////////////////
// WEBPACK FOOTER
// ./src/view/images/LOGO-1.png
// module id = Wmmp
// module chunks = 1